module.exports = __webpack_public_path__ + "static/img/saasliuliang_tubiao.670a519d.png";